module.exports = __webpack_public_path__ + "img/slika10.6b0b52e1.jpg";